import React from 'react'
import ReactDOM from 'react-dom'
import Appstore from "./App"
ReactDOM.render(
    <Appstore/>
    ,
  document.querySelector('body')
)

